import React, { Suspense, useRef, useState } from 'react'
import { Container, Content } from 'rsuite'
import { Outlet } from 'react-router'
import { Header, Footer, SideNav, SectionLoader } from '../shared'
import MfaGraceBanner from '../pages/mfaSetup/MfaGraceBanner'
import { useClosePickersOnScroll } from '../hooks/useClosePickersOnScroll'
import { useScrollToTopOnNavigate } from '../hooks/useScrollToTopOnNavigate'

const AuthLayout: React.FC = () => {
  useClosePickersOnScroll()

  // `.rs-content` is the app's scroller (the body is locked), so it's the thing
  // that has to be reset between routes — see the hook for why.
  const contentRef = useRef<HTMLElement>(null)
  useScrollToTopOnNavigate(contentRef)

  // Off-canvas nav state — only meaningful on phones. On desktop the sidebar
  // is always visible and this flag is ignored by the CSS. Toggled by the
  // header hamburger; closed on overlay tap or when a nav item is selected.
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  return (
    <Container className="layout">
      <Header onMenuToggle={() => setMobileNavOpen((open) => !open)} />
      <MfaGraceBanner />
      <Container>
        <SideNav
          mobileOpen={mobileNavOpen}
          onMobileClose={() => setMobileNavOpen(false)}
        />
        {/* Dimmed backdrop behind the slide-in nav on phones. */}
        <button
          type="button"
          aria-label="Close menu"
          className={`layout__nav-overlay${
            mobileNavOpen ? ' layout__nav-overlay--visible' : ''
          }`}
          onClick={() => setMobileNavOpen(false)}
        />
        <Content className="content" ref={contentRef}>
          <Suspense fallback={<SectionLoader />}>
            <Outlet />
          </Suspense>
        </Content>
      </Container>
      <Footer />
    </Container>
  )
}

export default AuthLayout
